import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const ordersFinanceListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Forder-management%2Forder-confirmed-seo.png?alt=media&token=b58c4d75-9a02-4a3f-97ab-ad92a24e52a4",
  title: "Orders & Finance",
  subtitle: "Easy Orders. Secure Finances.",
  page: WildNavigationType.ORDERSFINANCE,
}